import statisticsReducers from '../statisticsReducer';

export default statisticsReducers({
    apiDataFieldName: 'avgInTimes',
    statisticsActionName: 'AVERAGE_TIME_IN_APM',
});
